import api from '../common/api';
import { APIError } from '../constants/errorCode/system';
import BaseServices from './baseServices';

export default {
  getCurrent: async () => {
    try {
      const data = await BaseServices.getDataToken(api.getUser);
      const result = await data.json();
      return result;
    } catch (error) {
      return { isSuccess: false, code: APIError.ConnectFail };
    }
  },
  changePassword: async (password, newPassword) => {
    try {
      const data = await BaseServices.putDataToken(api.changePassword, {
        currentPassword: password,
        newPassword,
      });
      const result = await data.json();
      return result;
    } catch (error) {
      throw new Error(error);
    }
  },
  getUserByType: async (type, page, offset) => {
    try {
      const data = await BaseServices.getDataToken(api.getUserByType + type + '?page=' + page + '&offset=' + offset);
      const result = await data.json();
      return result;
    } catch (error) {
      throw new Error(error);
    }
  },
  updateUserStatus: async (id, status) => {
    try {
      const data = await BaseServices.putDataToken(api.updateUserStatus, { id, status });
      const result = await data.json();
      return result;
    } catch (error) {
      throw new Error(error);
    }
  },
  checkPassword: async (params) => {
    try {
      const url = api.users.checkPassword;
      const data = await BaseServices.postDataToken(url, params);
      return await data.json();
    } catch (error) {
      throw error;
    }
  },
  getRoleActions: async () => {
    try {
      const url = api.users.getRoleActions;
      const data = await BaseServices.getDataToken(url);
      return await data.json();
    } catch (error) {
      throw error;
    }
  },
  getLoginUserData: async (userId) => {
    try {
      const url = api.users.getLoginUserData.replace(':id', userId);
      const data = await BaseServices.getDataToken(url);
      return await data.json();
    } catch (error) {
      throw error;
    }
  },
};
